import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import * as membershipActions from "../../actions/membershipActions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Page from "../Page";
import Box from "../Box";
import LoadingContent from "../LoadingContent";

class MembershipTypePage extends PureComponent {
    static propTypes = {        
        history: PropTypes.object.isRequired,
        me: PropTypes.object.isRequired,
        storeJoinRenewMembershipType: PropTypes.func.isRequired,
        storeRegistrationMembershipType: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            membershipType: null,
        };
    }

    componentDidMount = () => {
        if (this.props.me.availableMembershipTypes.filter(m => !m.disabledForUser).length === 0) {
            this.props.history.push("/sessions");
        } else {
            const membershipType = this.props.me.availableMembershipTypes.find(m => m.useForJoinCampaign === true);
            if (membershipType) {
                this.setState({ membershipType: membershipType.membershipTypeName });
            }            
        }
    }

    _changeSelectedMembershipType = e => {
        this.setState({ membershipType: e.target.value });
    }

    _noThanksClicked = () => {
        this.props.storeJoinRenewMembershipType("");
        if (this.props.history.location.state && this.props.history.location.state.fromCheckout) {
            this.props.history.push("/checkout");
        }
        else {
            this.props.history.push("/sessions");
        }
    }

    _continueClicked = () => {
        let { membershipType } = this.state;
        if (!membershipType) {
            alert("Select a membership type");
            return;
        }
        
        this.props.storeJoinRenewMembershipType(membershipType);                

        if (this.props.history.location.state && this.props.history.location.state.fromCheckout) {
            this.props.history.push("/checkout");
        }
        else {
            this.props.history.push("/sessions");
        }        
    }

    render() {
        if (this.state.loading) {
            return <LoadingContent />
        }

        let { availableMembershipTypes } = this.props.me;
        return (
            <Page title="Conference Registration">
                <Box title="AANP Membership">                
                    <div className="inner-content">
                        {availableMembershipTypes.map(membershipType => (                                                                        
                            <div key={membershipType.productId} className="mb-2">
                                <input type="radio" value={membershipType.membershipTypeName} checked={this.state.membershipType === membershipType.membershipTypeName} onChange={this._changeSelectedMembershipType} id={membershipType.productId} hidden={membershipType.disabledForUser}/>
                                <label htmlFor={membershipType.productId} className="pl-2" hidden={membershipType.disabledForUser}>
                                    {membershipType.productWebName} (${membershipType.price.toFixed(2)})  {membershipType.disabledForUser ? " - " + membershipType.disabledForUserDisplayReason : ""}
                                </label>                            
                            </div>    
                        ))}
                    </div>

                    <div className="button-container mt-2">
                        <div className="inner-content">
                            <div className="row">
                                <div className="col pr-2">
                                    <button className="btn btn-primary btn-block" onClick={e => this._noThanksClicked()}>No Thanks</button>
                                </div>
                                <div className="col pl-2">
                                    <button className="btn btn-primary btn-block" onClick={e => this._continueClicked()}>Continue</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Box>
            </Page>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        me: state.account.me,
    };
};

export default withRouter(connect(mapStateToProps, membershipActions)(MembershipTypePage));